import {authHeader, ApiConfigs} from "../_helpers";
import { authService } from "./auth.service";

export const permissionService = {
    getAll,
    change,
    getAllWithPagination,

};

function getAll() {
    const requestOptions = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        credentials : 'include' as RequestCredentials, 
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.permissions.getAll}`, requestOptions)
        .then(
            handleResponse
        );
}

function getAllWithPagination(currentPage: number, perPage:any) {
    const requestOptions = {
        method: "GET",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" }, 
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.permissions.getAll}?page=${currentPage}&per_page=${perPage}`, requestOptions)
        .then(
            handleResponse
        );
}

function change(id: string, formData:FormData) {
    const requestOptions = {
        method: "POST",
        headers: { "Accept": "application/json" },
        credentials : 'include' as RequestCredentials,
        body: formData,
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.permissions.add.replace(':id', id)}`, requestOptions)
        .then(
            handleResponse
        );
}


function handleResponse(response: any) {
    return response.text().then((text: string) => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                localStorage.removeItem('user');

                location.reload();
                authService.logout();
            }
            const error = (data && data.message) || response.status || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}
